export const addressValidationPattern = /^[\p{Script=Latin}\p{Mark}0-9 /'\-\.]{1,80}$/u
